import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonFunctionService } from "./../../../services/Common/common-function.service";
import { UserMerchantData } from "./../../../services/Common/common-function.service";
const _clone = (d) => JSON.parse(JSON.stringify(d));
import { Validators, FormControl } from "@angular/forms";
import * as XLSX from 'xlsx';
import { TransactionService } from 'src/app/services/transaction/transaction.service';
import { PayoutService } from 'src/app/services/payout.service';
@Component({
  selector: 'app-payout-reports',
  templateUrl: './payout-reports.component.html',
  styleUrls: ['./payout-reports.component.scss']
})
export class PayoutReportsComponent implements OnInit {
  rowdata:any=[];
  FullAccountNumber:any;
  PaymentType= new FormControl("", []);
  TransactionType= new FormControl("", []);
  PayOutBeneficiaryKeyId= new FormControl("", []);
  PayoutCustomerkeyId= new FormControl("", []);
  Status= new FormControl("", []);
  isStartDateGreaterthenEndDate: boolean = false;
  isCustomDateSelected: boolean = false;
  isreportsbtnActive: boolean = false;
  fromdate = new FormControl("", [Validators.required]);
  Fromdate1: any;
  todate1: any;
  todate = new FormControl("", [Validators.required]);
  Statuslist= [
    { text: "Pending", value: "Pending" },
    { text: "Transaction Initiated", value: "Transaction Initiated" },
    { text: "Failed", value: "Failed" },
    { text: "Transferred", value: "Transferred" },
    { text: "Cancelled", value: "Cancelled" },
    { text: "All", value: "All" },


  ];
  TTypelist= [
    { text: "Debit", value: "Debit" },
    { text: "Credit", value: "Credit" },
    { text: "VerifyBeneficiary", value: "VerifyBeneficiary" },
  ];
  Ptypelist= [
    { text: "IMPS", value: "IMPS" },
    { text: "NEFT", value: "NEFT" },
    { text: "RTGS", value: "RTGS" },
    { text: "All", value: "All" },
  ];
  symbol = [
    { text: "=", value: "=" },
    { text: "<", value: "<" },
    { text: ">", value: ">" },
    { text: "<=", value: "<=" },
    { text: ">=", value: ">=" },
    { text: "<>", value: "<>" },

  ];
  Range = [
    { text: "Today", value: "0" },
    { text: "Yesterday", value: "1" },
    { text: "current week", value: "2" },
    { text: "Last Week", value: "3" },
    { text: "This Month", value: "4" },
    { text: "Last Month", value: "5" },
    { text: "Custom Date Range", value: "6" }
  ];
  amountcheck= new FormControl("", [Validators.required]);
  AccountNumber= new FormControl("", [Validators.required]);
  TransactionId= new FormControl("", [Validators.required]);
  Amount= new FormControl("", [Validators.required]);
  BankName= new FormControl("", [Validators.required]);
  daterange = new FormControl("", [Validators.required]);
  filtering: boolean = false;
  Dfiltering: boolean = true;
  Rfromdate: boolean = false;
  excelTansactionDataResponse = [];
  excelTranStatus: any;
  loggedinuseremail:any;
  MerchantKeyId:any;
  editing = {};
  rows = [];
  rowsFilter = [];
  rowsExp = [];
  rowsSort = [];
  rowsSel = [];
  selected = [];
  temp = [];
  expanded: any = {};
  constructor(private commonfunction: CommonFunctionService, private transactionservice: TransactionService,private service: PayoutService) { 
    this.getTransactiondetails();
  }

  ngOnInit() {
  }

  getTransactiondetails() {
    let merchantdata: UserMerchantData = this.commonfunction.getUserMerchantData();
    this.loggedinuseremail = this.commonfunction.getUserId();
    // this.loggedinuseremail=null;
    
  this.MerchantKeyId = merchantdata.MerchantKeyId;
  
    this.GetTransactionList((data) => {
      // cache our list
      this.temp = _clone(data);
      this.rows = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);



      this.rows.forEach(element => {
        if (element.AccountNumber !=null) {
        var first6digits = element.AccountNumber.slice(0, 6);
       var last4digits = element.AccountNumber.slice(-4);
          element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
        }
        if (element.TransactionType =="Credit" || element.TransactionType =="CREDIT") {
          element.TransactionType ="Credit";
        }
      });
    });
  }
  GetTransactionList(cb) {
    // const req = new XMLHttpRequest();
    // req.open('GET', environment.GetPayOutReportsUrl + "?MerchantKeyId=" + this.MerchantKeyId + "&UserId="+this.loggedinuseremail);
   
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };

    // req.send();
    
    this.service.getpayoutReports(this.MerchantKeyId,this.loggedinuseremail).subscribe(data => {
      if(data!=null){
        this.rows = _clone(data);;
      }
    });
  }


  
  readAndExportToExcelData() {
    const workBook: XLSX.WorkBook = XLSX.utils.book_new();
    if (this.rows.length > 0) {
      this.rows.forEach(element => {

        if (element.Status == 0) {
          this.excelTranStatus = 'Pending';
        }
        else if (element.Status == 1) {
          this.excelTranStatus = 'Transaction Initiated';
        }
        else if (element.Status == 2) {
          this.excelTranStatus = 'Failed';
        }
        else if (element.Status == 3) {
          this.excelTranStatus = 'Transferred';
        }
        else if (element.Status == 4) {
          this.excelTranStatus = 'Cancelled';
        }
        else {
          this.excelTranStatus = '';
        }
        var manageTranArray = {'Status':this.excelTranStatus,'Response': element.ResponseText,'Transaction Id': element.TransactionId,'Transaction Type': element.TransactionType, 'Payment Type': element.PaymentType,
         'Amount': element.Amount,'RequestUniqueId':element.RequestUniqueId,'Payout Customer keyId':element.PayoutCustomerkeyId ,
         'FirstName': element.FirstName,  'LastName': element.LastName,  'MobileNo': element.MobileNo
         ,  'PayOut Beneficiary KeyId': element.PayOutBeneficiaryKeyId,  'Beneficiary Name': element.BeneficiaryName,  'BankName': element.BankName
         ,  'Account Number': element.AccountNumber,  'Transaction Datetime': element.UpdatedDatetime}
        this.excelTansactionDataResponse.push(manageTranArray);
      });

      const manageTransactionWorkSheet = XLSX.utils.json_to_sheet(this.excelTansactionDataResponse,
         { header: ['Status', 'Response','Transaction Id', 'Transaction Type','Payment Type', 'Amount','RequestUniqueId','Payout Customer keyId', 'FirstName',
          'LastName', 'MobileNo'
          , 'PayOut Beneficiary KeyId', 'Beneficiary Name', 'BankName', 'Account Number', 'Transaction Datetime'] });
      XLSX.utils.book_append_sheet(workBook, manageTransactionWorkSheet, 'ManagePayoutTransaction_tbl');
    }
    XLSX.writeFile(workBook, "Excel" + new Date().getTime() + '.xlsx');
    this.excelTansactionDataResponse = [];
  }

  filters() {
    this.filtering = !this.filtering;
  }

  selectedaterange() {
    var daterange = this.daterange.value;
    if (daterange == "Custom Date Range") {
      this.isCustomDateSelected = true;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = true;
      this.Dfiltering = false;
    }
    else {
      this.isCustomDateSelected = false;
      this.isStartDateGreaterthenEndDate = false;
      this.Rfromdate = false;
       this.search();

    }
  }

  search() {
    this.GetPayOutTransactionfilter((data) => {
      // cache our list
      // this.temp = _clone(data);
      // this.rows = _clone(data);;
      // this.rowsFilter = _clone(data);;
      // this.rowsExp = _clone(data);
      // this.rowsSort = _clone(data);
      // this.rowsSel = _clone(data);
      // this.rows.forEach(element => {
      //   if (element.AccountNumber !=null) {
      //   var first6digits = element.AccountNumber.slice(0, 6);
      //  var last4digits = element.AccountNumber.slice(-4);
      //     element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
      //   }
      //   if (element.TransactionType =="Credit" || element.TransactionType =="CREDIT") {
      //     element.TransactionType ="Credit";
      //   }
      // });
    });
 
  }
  GetPayOutTransactionfilter(cb) {
    var daterange = this.daterange.value;
    var Tid = this.TransactionId.value;
    if(Tid=="")
    {
      Tid="0";
    }
    var AccountNumber = this.AccountNumber.value;
    var Status = this.Status.value;
    if(Status=="Pending")
    {
      Status="0";
    }
    else if(Status=="Transaction Initiated")
    {
      Status="1";
    }
    else if(Status=="Failed")
    {
      Status="2";
    }
    else if(Status=="Transferred")
    {
      Status="3";
    }
    else if(Status=="Cancelled")
    {
      Status="4";
    }
    else
    {
      Status="5";
    }
    var TransactionType = this.TransactionType.value;   
     var PaymentType = this.PaymentType.value;
     if(PaymentType=="All")
     {
      PaymentType="";
     }
     var PayOutBeneficiaryKeyId = this.PayOutBeneficiaryKeyId.value;   
    var PayoutCustomerkeyId = this.PayoutCustomerkeyId.value;
    var amountcompare = this.amountcheck.value;
    var Amount = this.Amount.value;
    if(Amount=="")
    {
     Amount="0";
    }

    if (daterange == "Today") {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);


    }
    else if (daterange == "Yesterday") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDate() - 1)).toISOString().slice(0, 10);
      this.Fromdate1 = tomorrow;
      this.todate1 = tomorrow;

    }
    else if (daterange == "current week") {
      const today = new Date();
      const tomorrow = new Date(today.setDate(today.getDay()));


      var current = new Date();
      var weekstart = current.getDate() - current.getDay() + 1;
      var weekend = weekstart + 6;
      this.Fromdate1 = new Date(current.setDate(weekstart)).toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Week") {
      var curr = new Date;
      var first = curr.getDate() - curr.getDay() - 6;
      var last = first + 6;
      this.Fromdate1 = new Date(curr.setDate(first)).toISOString().slice(0, 10);
      this.todate1 = new Date(curr.setDate(last)).toISOString().slice(0, 10);


    }
    else if (daterange == "This Month") {
      const today = new Date();
      // const thismonth = new Date(today.setDate(today.getMonth())).toISOString().slice(0, 10);
      //this.Fromdate1=thismonth;   
      this.Fromdate1 = new Date(today.getFullYear(), today.getMonth(), 1).toDateString();
      this.todate1 = new Date().toISOString().slice(0, 10);

    }
    else if (daterange == "Last Month") {
      // var date = new Date();                
      // this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toISOString().slice(0,10);
      // this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toISOString().slice(0,10);
      var date = new Date();
      this.Fromdate1 = new Date(date.getFullYear(), date.getMonth() - 1, 1).toDateString();
      this.todate1 = new Date(date.getFullYear(), date.getMonth() - 1 + 1, 0).toDateString();


    }
    else if (daterange == "Custom Date Range") {

      this.Fromdate1 = this.fromdate.value;
      this.todate1 = this.todate.value;
    }
    else {
      this.Fromdate1 = new Date().toISOString().slice(0, 10);
      this.todate1 = new Date().toISOString().slice(0, 10);
    }

    const req = new XMLHttpRequest();
    // req.open('GET',
    //   environment.PayOutReportsFilter + "?MerchantKeyId=" + this.MerchantKeyId + "&fromdate=" + this.Fromdate1 + "&todate=" + this.todate1 + "&AccountNumber=" + AccountNumber
    //   + "&TransactionId=" + Tid +"&Status=" + Status  + "&Amount=" + Amount + "&AmountCheck=" + amountcompare
    //   + "&TransactionType=" + TransactionType
    //   + "&PaymentType=" + PaymentType
    //   + "&PayOutBeneficiaryKeyId=" + PayOutBeneficiaryKeyId
    //   + "&PayoutCustomerkeyId=" + PayoutCustomerkeyId);
    // req.onload = () => {
    //   cb(JSON.parse(req.response));
    // };
  
    // req.send();
    this.service.getpayoutreportfilter(this.MerchantKeyId,this.Fromdate1,this.todate1,AccountNumber,Tid,Status,Amount,amountcompare,TransactionType,PaymentType,PayOutBeneficiaryKeyId,PayoutCustomerkeyId).subscribe(data => {
      if(data !=null)
      {
      this.temp = _clone(data);
      this.rows = _clone(data);;
      this.rowsFilter = _clone(data);;
      this.rowsExp = _clone(data);
      this.rowsSort = _clone(data);
      this.rowsSel = _clone(data);
      this.rows.forEach(element => {
        if (element.AccountNumber !=null) {
        var first6digits = element.AccountNumber.slice(0, 6);
       var last4digits = element.AccountNumber.slice(-4);
          element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
        }
        if (element.TransactionType =="Credit" || element.TransactionType =="CREDIT") {
          element.TransactionType ="Credit";
        }
      });
    }
    });

  }

  checkRangeType()
  {
    var daterange=this.daterange.value;
    if(daterange=="Custom Date Range")
    {
     this.isCustomDateSelected = true;
     this.isStartDateGreaterthenEndDate = false;
        this.Rfromdate=true;
       this. Dfiltering=false;
       this.fromdate.setValue('');
       this.todate.setValue('');
       this.isreportsbtnActive = false;
    }
    else{
     this.isCustomDateSelected = false;
     this.isStartDateGreaterthenEndDate = false;
     this.Rfromdate=false;   
    }
  }
  viewtransactiondetails(Id:any,mid:any){
    this.service.ViewPayOutTransactionDetails(Id,mid).subscribe(result => {
      //  if(result.InternalPurpose=="Received" && result.TransactionType=="CREDIT" && result.PayoutCustomerkeyId !=null && result.PayoutCustomerkeyId !="")
      //  {
      //     this.Reciviedfrom=result.FirstName + " " + result.LastName;
      //     this.Recivieddata=true;
            
  
      //  }
      this.rowdata=result;
  
       if(result.AccountNumber !=null)
       {
         this.FullAccountNumber=this.rowdata.AccountNumber
        var first6digits = this.rowdata.AccountNumber.slice(0, 6);
        var last4digits = this.rowdata.AccountNumber.slice(-4);
        this.rowdata.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
       }
  
      //  this.rows.forEach(element => {
      //   if (element.AccountNumber !=null) {
      //   var first6digits = element.AccountNumber.slice(0, 6);
      //  var last4digits = element.AccountNumber.slice(-4);
      //     element.AccountNumber = first6digits+"-XXXXXXX-"+last4digits;
      //   }
       
      // });
  
  
  
      //  if(this.rows.Status==0)
      //  {
      //    this.rows.Status="Pending"
      //  }
      //  else if(this.rows.Status==1)
      //  {
      //    this.rows.Status="Transaction Initiated"
      //  }
      //  else if(this.rows.Status==2)
      //  {
      //    this.rows.Status="Failed"
      //  }
      //  else if(this.rows.Status==3)
      //  {
      //    this.rows.Status="Transferred"
      //  }
      //  else if(this.rows.Status==4)
      //  {
      //    this.rows.Status="Cancelled"
      //  }
       if(result.BankCodeType==0)
      {
        result.BankCodeType="RoutingTransitNumber"
      }
      else if(result.BankCodeType==1)
      {
        result.BankCodeType="BankSortCodes"
      }
      else if(result.BankCodeType==2)
      {
        result.BankCodeType="BsbNumbers"
      }
      else if(result.BankCodeType==3)
      {
        result.BankCodeType="SwiftCode"
      }
      else if(result.BankCodeType==4)
      {
        result.BankCodeType="MicrCode"
      }
      else if(result.BankCodeType==5)
      {
        result.BankCodeType="IfscCode"
      }
      if(result.BankAccountType==0)
      {
        result.BankAccountType="SalaryAccount"
      }
      else if(result.BankAccountType==1)
      {
        result.BankAccountType="CurrentAccount"
      }
      else if(result.BankAccountType==2)
      {
        result.BankAccountType="SavingAccount"
      }
      else if(result.BankAccountType==3)
      {
        result.BankAccountType="RecurringDeposits"
      }
      else if(result.BankAccountType==4)
      {
        result.BankAccountType="FixedDeposits"
      }
      // if(this.CreatedBy!=null && this.CreatedBy!='' && this.CreatedBy!=undefined){
      //   this.getmerchantdetailsbyuserid();
      // }
      // if(this.ApprovedBy!=null && this.ApprovedBy!=''){
      //  this.getuserdetails();
      // }
    
      })
  }
  checkDateRange() {
    if (this.fromdate.value != "" && this.todate.value != "") {
      if (this.fromdate.value > this.todate.value) {
        this.isreportsbtnActive = false;
        this.isStartDateGreaterthenEndDate = true;
      }
      else {
        this.isreportsbtnActive = true;
        this.isStartDateGreaterthenEndDate = false;
      }
    }
    else {
      this.isreportsbtnActive = false;
      this.isStartDateGreaterthenEndDate = false;
    }
  }
}
